// src/Redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_ROUTES } from '../Constants/apiRoutes';
import axiosWithAuth from '../UtilsRedux/axiosWithAuth';

export const fetchUserProfile = createAsyncThunk(
    'auth/fetchUserProfile',
    async (idToken) => {
        const res = await axios.get(`${API_ROUTES.SIGN_IN}?t=${Date.now()}`, {
            headers: { Authorization: `Bearer ${idToken}` }
        });
        // normalize
        return res.data?.userFlat || {
            ...res.data.user,
            entitlements: res.data.entitlements,
            paymentDetails: res.data.paymentDetails,
            subscription: res.data.subscription,
        };
    }
);


export const updateUserProfile = createAsyncThunk(
    'auth/updateUserProfile',
    async ({ token, updates }) => {
        // Update
        await axios.put(API_ROUTES.ONBOARDING_UPDATE, updates, {
            headers: { Authorization: `Bearer ${token}` },
        });
        // Re-fetch /me so we have the full, current shape
        const me = await axios.get(API_ROUTES.SIGN_IN, {
            headers: { Authorization: `Bearer ${token}` },
        });
        // normalize
        return me.data?.userFlat || {
            ...me.data.user,
            entitlements: me.data.entitlements,
            paymentDetails: me.data.paymentDetails,
            subscription: me.data.subscription,
        };
    }
);


const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: JSON.parse(localStorage.getItem("user")) || null,
        token: localStorage.getItem("token") || null,
        loading: false,
        error: null,
        bootstrapped: !!localStorage.getItem("user"),
    },

    reducers: {
        clearAuthState: (state) => {
            state.user = null;
            state.error = null;
            state.token = null;
            state.loading = false;
            state.bootstrapped = false; 
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
            state.bootstrapped = true;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setBootstrapped: (state, action) => { state.bootstrapped = action.payload; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUserProfile.fulfilled, (state, action) => {
                state.user = action.payload;                         // flat user
                state.loading = false;
                state.bootstrapped = true;
                localStorage.setItem('user', JSON.stringify(action.payload));
            })

            .addCase(updateUserProfile.fulfilled, (state, action) => {
                const updatedUser = action.payload; // already normalized above
                state.user = updatedUser;
                localStorage.setItem('user', JSON.stringify(updatedUser));
            })

            .addCase(updateUserSettings.fulfilled, (state, action) => {
                state.user = {
                    ...state.user,
                    settings: action.payload.settings,
                };
                localStorage.setItem('user', JSON.stringify(state.user));
            });

    }

});



// User Settings
export const updateUserSettings = createAsyncThunk(
    'auth/updateUserSettings',
    async ({ token, settings }) => {
        const res = await axios.patch(API_ROUTES.SETTINGS_UPDATE, settings, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data;
    }
);


export const { clearAuthState, setLoading, setUser, setError,setBootstrapped  } = authSlice.actions;

export default authSlice.reducer;
